export const USER_ROLE_TYPE_ENUM = {
  BUYER: 'company.role.buyer',
  SELLER: 'company.role.seller',
  SELLER_AND_BUYER: 'company.role.seller_and_buyer',
} as Record<string, string>;

export const OPERATION_MODE_TYPE_ENUM = {
  BUYER: 'operations.mode.buyer',
  SELLER: 'operations.mode.seller',
} as Record<string, string>;

export const COMPANY_VERIFICATION_STATUS = {
  ADDITIONAL_INFO_REQUIRED: 'company.verification.additional_info_required',
  APPROVED: 'company.verification.approved',
  ARCHIVE: 'company.verification.archive',
  DECLINED: 'company.verification.declined',
  NEEDS_REVIEW: 'company.verification.needs_review',
  PROCESSED: 'company.verification.processed',
  PROFILE_INCOMPLETE: 'company.verification.profile_incomplete',
} as const;

export const getQueryKey = () => [
  'userInfo',
  'currentUserRole',
  'currentOperationMode',
];
